export const styles = {
  topRightButtons: {
    zIndex: '999',
    elevation: '999',
    position: 'fixed',
    top: '1vh',
  },
  noteButton: {
    marginTop: '1%',
    minWidth: '15%',
    minHeight: '50px',
  },
  noteButtonVertical: {
    marginTop: '1%',
    padding: '3%',
    fontSize: '66px',
  },
  settingsButton: {
    marginTop: '1%',
    minWidth: '5%',
    minHeight: '20px',
  },
  settingsButtonVertical: {
    marginTop: '1%',
    padding: '1%',
    fontSize: '30px',
  },
  infoTitle: {
    fontSize: '25px',
    fontWeight: 'bold',
  },
  infoTitle2: {
    fontSize: '20px',
    textDecoration: 'underline',
  },
  selectionButtonVertical: {
    marginTop: '1%',
    minWidth: '4%',
    minHeight: '35px',
    fontSize: '66px',
  },
  selectionButton: {
    marginTop: '1%',
    minWidth: '4%',
    minHeight: '35px',
    fontSize: '26px',
  },
  selectionButtonVerticalInSettings: {
    marginTop: '1%',
    minWidth: '4%',
    minHeight: '35px',
    fontSize: '52px',
  },
  selectionButtonInSettings: {
    marginTop: '1%',
    minWidth: '4%',
    minHeight: '35px',
  },
  noteTextVertical: {
    fontSize: '90px',
  },
  noteText: {
    fontSize: '30px',
  },
  notesAndAnswers: {
    marginTop: '1%',
    minHeight: '50px',
  },
  clueStyle: {
    color: '#454ACE',
  },
  answerStyle: {
    color: '#B9C12F',
  },
  manuallyFoundStyle: {
    color: '#17B419',
  },
  textVertical: {
    fontSize: '70px',
  },
  text: {
    fontSize: '20px',
  },
}
